import { useEffect, useState } from "react";
import { Box, VStack } from "@chakra-ui/react"
import { Outlet } from "react-router-dom";
import NavBar from "./Navbar"
import Footer from "./Footer";
import ScrollToTop from "./ScrollToTop";

// Keep the mobile navbar showing within this distance (px) of the top of the page
const NAV_HIDE_OFFSET = 100;

// Minimum scroll distance (px) before the mobile navbar hides or shows
const SCROLL_THRESHOLD = 10;

export default function Layout() {

	// Show a shadow under the sticky navbar once the page has scrolled
	const [isScrolled, setIsScrolled] = useState(false);

	// On mobile, slide the navbar away while scrolling down and back when scrolling up
	const [isNavHidden, setIsNavHidden] = useState(false);

	useEffect(() => {
		let lastScrollY = window.scrollY;

		const handleScroll = () => {
			const scrollY = window.scrollY;
			setIsScrolled(scrollY > 0);

			// Always show it near the top of the page
			if (scrollY < NAV_HIDE_OFFSET) {
				setIsNavHidden(false);
			}
			// Ignore tiny movements so it doesn't flicker
			else if (Math.abs(scrollY - lastScrollY) > SCROLL_THRESHOLD) {
				setIsNavHidden(scrollY > lastScrollY);
			} else {
				return;
			}

			lastScrollY = scrollY;
		};
		handleScroll();

		window.addEventListener("scroll", handleScroll, { passive: true });
		return () => window.removeEventListener("scroll", handleScroll);
	}, []);

	return (
		<Box
			backgroundColor={"blue.100"}
			justifyContent={"center"}
		>
			<ScrollToTop />
			<VStack
				margin={"auto"}
				maxWidth="2000px"
				minHeight={"100vh"}
				gap={0}
				userSelect={"none"}
			>
				{/* Sticky Navbar: also the positioning parent for the mobile menu button */}
				<Box
					position={"sticky"}
					top={0}
					zIndex={"sticky"}
					width={"100%"}
					display={"flex"}
					justifyContent={"center"}
					backgroundColor={"blue.100"}
					boxShadow={isScrolled ? "0 4px 12px rgba(0, 0, 0, 0.3)" : "none"}
					// Hiding only applies on mobile; tablet and desktop keep it pinned
					transform={{ base: isNavHidden ? "translateY(-100%)" : "none", md: "none" }}
					transition={"box-shadow 0.2s ease, transform 0.3s ease"}
				>
					<NavBar />
				</Box>
				<Outlet />
				<Footer />
			</VStack>
		</Box>
	);
}
